var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Images"}},[_c('b-row',_vm._l((_vm.Images),function(image,index){return _c('b-col',{key:index},[_c('img',{attrs:{"src":image.src,"alt":image.alt}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }